<template>
  <v-footer app color="white" class="footer" v-if="buttons.length">
    <section class="footer-section app-section-width">
      <div class="button-container">
          <v-btn
            v-for="button in buttons"
            :key="button.id"
            color="primary lighten-1"
            class="button"
            :href="button.link"
            :target="button.link ? '_blank' : null"
            :to="button.urlTo"
          >
            {{ getTextTranslation(button.title) }}
          </v-btn>
      </div>
    </section>
  </v-footer>
</template>
<script>
import { getTextValue } from '@/lib/helpers/LocalizedText'

export default {
  props: {
    buttons: {
      type: Array,
      default: [],
    },
  },
  methods: {
    getTextTranslation (LocalizedText) {
      return getTextValue(LocalizedText)
    },
  },
}
</script>
<style scoped lang="scss">

.footer {
  box-shadow: 0px -10px 15px 0px rgba(0, 0, 0, 0.05) !important;
}

.footer-section {
  width: 100%;
  padding: 4px;
  margin-right: auto;
  margin-left: auto;
}

.button-container {
  display: flex;
  align-content: space-around;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
}

.button-container > * {
  flex-grow: 1;
}

.button {
  color: white;
}
</style>